/**
 * In the box — tap anywhere on the media to play / pause (no modal).
 */
(function () {
  var playLabelDefault = 'Play video';
  var pauseLabelDefault = 'Pause video';

  function setPlaying(media, toggle, isPlaying) {
    var playIcon = toggle.querySelector('[data-in-the-box-icon-play]');
    var pauseIcon = toggle.querySelector('[data-in-the-box-icon-pause]');
    var playLabel = toggle.getAttribute('data-play-label') || playLabelDefault;
    var pauseLabel = toggle.getAttribute('data-pause-label') || pauseLabelDefault;

    media.classList.toggle('is-playing', isPlaying);
    if (isPlaying) media.classList.add('has-started');
    toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    toggle.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);

    if (playIcon) playIcon.hidden = isPlaying;
    if (pauseIcon) pauseIcon.hidden = !isPlaying;
  }

  function pauseHtmlVideo(video, media, toggle) {
    if (!video) return;
    video.pause();
    setPlaying(media, toggle, false);
  }

  function resetHtmlVideo(video, media, toggle) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
    var videoWrap = media.querySelector('[data-in-the-box-video-wrap]');
    if (videoWrap) videoWrap.hidden = true;
    media.classList.remove('has-started');
    setPlaying(media, toggle, false);
  }

  function stopEmbed(media, toggle) {
    var embedWrap = media.querySelector('[data-in-the-box-embed-wrap]');
    var embed = media.querySelector('[data-in-the-box-embed]');
    if (embed) embed.removeAttribute('src');
    if (embedWrap) embedWrap.hidden = true;
    media.classList.remove('has-started');
    setPlaying(media, toggle, false);
  }

  function playHtmlVideo(video, media, toggle) {
    var videoWrap = media.querySelector('[data-in-the-box-video-wrap]');
    if (videoWrap) videoWrap.hidden = false;
    video.muted = false;
    setPlaying(media, toggle, true);
    video.play().catch(function () {
      video.muted = true;
      return video.play();
    }).catch(function () {
      resetHtmlVideo(video, media, toggle);
    });
  }

  function playEmbed(media, toggle) {
    var embedWrap = media.querySelector('[data-in-the-box-embed-wrap]');
    var embed = media.querySelector('[data-in-the-box-embed]');
    var youtubeId = media.getAttribute('data-youtube-id');
    var vimeoId = media.getAttribute('data-vimeo-id');

    if (!embed || (!youtubeId && !vimeoId)) return;

    if (youtubeId) {
      embed.src =
        'https://www.youtube.com/embed/' +
        youtubeId +
        '?autoplay=1&rel=0&playsinline=1';
    } else if (vimeoId) {
      embed.src =
        'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
    }

    if (embedWrap) embedWrap.hidden = false;
    setPlaying(media, toggle, true);
  }

  function initSection(section) {
    var media = section.querySelector('[data-in-the-box-media]');
    var toggle = section.querySelector('[data-in-the-box-toggle]');
    if (!media || !toggle) return;
    if (toggle.getAttribute('data-initialized') === 'true') return;
    toggle.setAttribute('data-initialized', 'true');

    var video = media.querySelector('.diagnox-in-the-box__video');
    var embed = media.querySelector('[data-in-the-box-embed]');

    function togglePlayback() {
      var isPlaying = media.classList.contains('is-playing');

      if (isPlaying) {
        if (video) pauseHtmlVideo(video, media, toggle);
        else if (embed) stopEmbed(media, toggle);
        return;
      }

      if (video) playHtmlVideo(video, media, toggle);
      else if (embed) playEmbed(media, toggle);
    }

    // Full-area control: click/tap anywhere on the media toggles play/pause
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      togglePlayback();
    });

    media.addEventListener('click', function (e) {
      if (e.target === toggle || toggle.contains(e.target)) return;
      e.preventDefault();
      togglePlayback();
    });

    if (video) {
      video.addEventListener('ended', function () {
        resetHtmlVideo(video, media, toggle);
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-diagnox-in-the-box]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
